const getCommonPageNames = (page: string) => {
  // Using (\d+) insead of matching clip_id directly
  if (/manage\/videos\/(\d+)/i.test(page)) {
    return 'single_video_view';
  }
  if (/\/manage\/folders/i.test(page)) {
    return 'folders';
  }
  if (/\/manage\/showcases/i.test(page)) {
    return 'showcase_cms';
  }
  if (/\/upload/i.test(page)) {
    return 'upload_page';
  }
  if (/\/manage\/videos/i.test(page)) {
    return 'video_manager';
  }
  if (/\/manage\/events/i.test(page)) {
    return 'event_manager';
  }
  if (/\/review\/(\d+)/i.test(page)) {
    return 'review_page';
  }
  if (/\/(\d+)/i.test(page)) {
    return 'clip_page';
  }
  if (/\/upgrade/i.test(page)) {
    return 'upgrade_page';
  }
  if (/\/watch$/i.test(page)) {
    return 'watch';
  }
  return null;
};

// returns pagename as window.location.pathname unless explicitly given a value
export const getPageName = <T extends string>(pathName: T) => {
  const pageName = getCommonPageNames(pathName);
  if (pageName) return pageName;
  if (pathName === '/' || pathName === '') return 'ss_lihp';
  if (pathName === '/home') return 'ss_lihp_mw';
  return pathName;
};

// Javascript version of controllers_v6/VideoSettingsController.php function _getEntryScreen
const getEntryPage = (referrer: string): string => {
  const pageName = getCommonPageNames(referrer);
  if (pageName) return pageName;
  /**
   * We need to account for dangling `/`s and language subfolders on the Vimeo homepage,
   * e.g. https://vimeo.com/fr/
   */
  // Remove domain specific characters from the string
  const topLevelWithPath = referrer.split('.').pop() as string;
  if (
    referrer.includes('vimeo') &&
    /(com|dev)\/?(es|de|fr|jp|pt-br|ko)?\/?$/i.test(topLevelWithPath)
  ) {
    return 'lihp';
  }
  return referrer;
};

export default getEntryPage;
